export const c_drawer__splitter_handle_Left = {
  "name": "--pf-c-drawer__splitter-handle--Left",
  "value": "calc(50% - 1px)",
  "var": "var(--pf-c-drawer__splitter-handle--Left)"
};
export default c_drawer__splitter_handle_Left;